import React, {CSSProperties} from 'react';
import { styles } from './styles';
import { MobileView, BrowserView } from 'react-device-detect';


export enum PanelType {
    LIGHT,
    MEDIUM,
}


export interface PanelProps {
    children?: React.ReactNode;
    type: PanelType;
    style?: CSSProperties;
}


export const Panel: React.FC<PanelProps> = ({children, type, style}) => {

    return (
        <div style={{
            ...(type == PanelType.LIGHT ? styles.lightPanel : styles.mediumPanel),
            ...styles.panel,
            ...style,
        }}>
            <MobileView>
                {children}
            </MobileView>

            <BrowserView>
                {children}
            </BrowserView>
        </div>
    );
};


